import Block from '@components/block';
import { FC } from 'react';
import styles from './chart-loading.module.scss';

const SwapChartLoading: FC = () => {
  return (
    <>
      <div className={styles.wrapper}>
        <div className={styles.top}>
          <div className={styles.symbol}>
            <Block className={styles.img} />
            <Block />
            <span>/</span>
            <Block className={styles.img} />
            <Block />
          </div>
          <div className={styles.tabs}>
            <Block />
          </div>
        </div>

        <div className={styles.bottom}>
          <Block />
        </div>
      </div>
    </>
  );
};

export default SwapChartLoading;
